import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" {...props}><path fillRule="evenodd" d="M32 7.733v20.533A3.735 3.735 0 0128.266 32H7.733A3.733 3.733 0 014 28.266V7.733A3.735 3.735 0 017.733 4h20.533A3.733 3.733 0 0132 7.733zm-1.5.148A2.381 2.381 0 0028.119 5.5H7.881A2.381 2.381 0 005.5 7.881v20.24A2.38 2.38 0 007.881 30.5h20.238a2.38 2.38 0 002.381-2.38V7.881z" /></svg>);